import React,{useState} from 'react';

const Contact = () => {
    const [user,setUser]=useState({
        name:"",
        email:"",
        subject:"",
        textarea:"",
    });
    let name,value;
    const getUserData=(event)=>{
    name=event.target.name;
    value=event.target.value;
    setUser({ ...user,[name]:value})
    }

    const postData=async (e)=>{
    e.preventDefault();
    const {name,email,subject,textarea}=user;
    if(name && email && subject && textarea){
        const res =await fetch("https://reactform-1a098-default-rtdb.firebaseio.com/youtubereactform.json",{
            method:"POST",
            headers:{
                "Content-Type":"application/json",
            },
            body:JSON.stringify({
                name,
                email,
                subject,
                textarea,
            })
         })
    
    
    if(res){
        setUser({
            name:"",
            email:"",
            subject:"",
            textarea:"",
        });
    
        alert("Data Stored Successfully ")
    }
    
    }else{
alert("Please fill alll the fields")
    }
    

     
    }

  return (
  <section id="contact" className='pb-16'>
    <div className="container">
        <h2 className='text-headingColor font-[700] text-[2.5rem] mb-8 '>Get in touch</h2>
        <div className="md:flex justify-between items-center">
            <div className="w-full md:w-1/2 h-[300px] sm:h-[450px]">
            <iframe title='google-maps' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117371.06201392043!2d79.88635019463173!3d23.175831480242717!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3981ae1a0fb6a97d%3A0x44020616bc43e3b9!2sJabalpur%2C%20Madhya%20Pradesh!5e0!3m2!1sen!2sin!4v1685240055383!5m2!1sen!2sin"className='border-0 w-full h-full' allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <div className="w-full mt-8 md:mt-0 md:w-1/2 sm:h-[450px] lg:flex items-center bg-indigo-200 px-4
            lg:px-8 py-8 ">
                <form className='w-full' method='POST' >
                    <div className="mb-5" >
                        <input type="text" name='name' autoComplete='off' required placeholder='Enter your name' value={user.name}   onChange={getUserData}  className='w-full p-3 focus:outline-none rounded-[5px]' />
                    </div>
                    <div className="mb-5">
                        <input type="email"name='email' autoComplete='off' required placeholder='Enter your email' value={user.email}  onChange={getUserData}className='w-full p-3 focus:outline-none rounded-[5px]' />
                    </div>
                    <div className="mb-5">
                        <input type="text" name='subject' autoComplete='off' required placeholder='Contact number' value={user.subject} onChange={getUserData} className='w-full p-3 focus:outline-none rounded-[5px]' />
                    </div>

                    <div className="mb-5">
                        <textarea type="text"  name='textarea' autoComplete='off' required rows={3} placeholder='what can i do for you' value={user.textarea} onChange={getUserData} className='w-full p-3 focus:outline-none rounded-[5px]'/>
                    </div>
                    <button className='w-full p-3 focus:outline-none rounded-[5px] bg-smallTextColor text-white hover:bg-headingColor text-center text-center ease-linear duration-150' onClick={postData} >Send Message</button>
                    
                </form>
            </div>
        </div>
    </div>
  </section>
  );
}

export default Contact;
